import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";
import "animate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChartPie,
    faCommentsDollar,
    faGlobe,
    faLightbulb,
    faPeopleCarryBox,
    faUsersGear
} from "@fortawesome/free-solid-svg-icons";
import Carousel from "../components/Carousel";
import loginIMG from "../images/login.png";
import mamitoIMG from "../images/mamito.jpeg";
import girlieIMG from "../images/girlie.jpeg";
import broIMG from "../images/bro.jpeg";
import homeBg from "../images/red-map.webp";
import useInView from "../lib/useInView";
import ReactPlayer from "react-player";
import MarketMarquee from "../components/MarketMarque";



const HomePage = () => {
    const navigate = useNavigate();
    const words = ["Online Banking", "Fintech Solution", "Secure Transactions"];
    const [currentWordIndex, setCurrentWordIndex] = useState(0);

    // Cycle through words every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [words.length]);

    // to handle animations using the custom 'in view' hook
    const [boxImageRef, boxImageInView] = useInView({ threshold: 0.5 });
    const [boxVidRef, boxVidInView] = useInView({ threshold: 0.5 });
    const [boxImgRef, boxImgInView] = useInView({ threshold: 0.5 });
    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
    const [box2Ref, box2InView] = useInView({ threshold: 0.7 });
    const [box3Ref, box3InView] = useInView({ threshold: 0.7 });
    const [box4Ref, box4InView] = useInView({ threshold: 0.7 });
    const [box5Ref, box5InView] = useInView({ threshold: 0.7 });
    const [box6Ref, box6InView] = useInView({ threshold: 0.7 });
    const [box7Ref, box7InView] = useInView({ threshold: 0.7 });
    const [box8Ref, box8InView] = useInView({ threshold: 0.7 });
    const [box9Ref, box9InView] = useInView({ threshold: 0.7 });




    // Determine width and height based on screen size for YouTube
    const screenWidth = window.innerWidth;
    const isMobile = screenWidth <= 600;
    const isTablet = screenWidth > 600 && screenWidth <= 1000;
    const width = isMobile ? "500px" : isTablet ? "700px" : "100%";
    const height = isMobile ? "300px" : isTablet ? "400px" : "350px";


    return (
        <>
            <div id="hero-section">
                <div className="hero-section">
                    {/* Left Box: Text and Sub-Boxes */}
                    <div className="hero-text-container">
                        <h1 className="hero-title">
                            Fit your financial life with our <span className="handwriting">{words[currentWordIndex]}</span>
                        </h1>
                        <p className="hero-description">
                            We help clients find ways to turn actionable insights by embedding economics across their organization’s strategy and budget.
                        </p>
                        <h2 className="hero-description">
                            Turn your plans into <span className="circle-text">goals</span>
                        </h2>
                    </div>


                </div>

                {/* Display Sliding Carousel */}
                <Carousel />
            </div>
            <MarketMarquee />

            {/* main page content */}
            <div className="heading-cover-bg">
                <div className="last-section extra">
                    {/* Box 1: Text */}
                    <div className="box">
                        <h2 className="box-title">A Bank That  Actually Cares</h2>
                        <div className="box-text">
                            Every day, there are new challenges for your business.
                            When every decision matters, do you have the right financial partner to help you get it right?
                        </div>
                        <div className="box-text">
                            When you work with the professional business bankers,
                            you’re working with knowledgeable local advisors who take the time to truly understand your business.
                            We’ll work with you so that you can take advantage of opportunities when they come your way.
                            We’ll help you see all your options and work with you to find the right one, so you can confidently move forward to take your business to the next level.
                        </div>
                    </div>

                    {/* Box 2: Image */}
                    <div className="box">
                        <img
                            src={homeBg}
                            alt="Couples"
                            ref={boxImageRef}
                            className={`box-image animate__animated ${boxImageInView ? "animate__zoomIn" : ""}`}
                        />
                    </div>

                    {/* Box 3: Icon, Heading, and Text */}
                    <div className="box">
                        <div
                            ref={box6Ref}
                            className={`icon-title-text-container animate__animated ${box6InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faLightbulb} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title">
                                    DEFINE YOUR VISION
                                </h3>
                                <div className="box-text">
                                    Set a clear direction for where your business is headed today, tomorrow, and beyond.
                                </div>
                            </div>
                        </div>

                        <div
                            ref={box5Ref}
                            className={`icon-title-text-container animate__animated ${box5InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faUsersGear} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title">
                                    BUILT AROUND YOUR NEEDS
                                </h3>
                                <div className="box-text">
                                    Every solution is crafted to fit your goals, with flexibility to grow as you do.
                                </div>
                            </div>
                        </div>

                        <div
                            ref={box4Ref}
                            className={`icon-title-text-container animate__animated ${box4InView ? "animate__zoomInRight" : ""}`}
                        >
                            <FontAwesomeIcon icon={faPeopleCarryBox} className="box-icon" />
                            <div className="title-text">
                                <h3 className="box-title">
                                    PARTNER IN SUCCESS
                                </h3>
                                <div className="box-text">
                                    Collaborate with us to make smart decisions and move forward with confidence.
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => navigate("/login")}
                            className="delete-button">
                            Get Started
                        </button>
                    </div>

                </div>

                {/* three column content is next */}
                <h2 className="text-heading center">
                    Exchange Money Internationally in minutes
                </h2>
                <div className="three-box-container">
                    <div
                        ref={box1Ref}
                        className={`box box-cover animate__animated ${box1InView ? "animate__zoomIn" : ""}`}
                    >
                        <FontAwesomeIcon icon={faGlobe} className="box-icon" />
                        <h3 className="box-title center">
                            Global Banking
                        </h3>
                        <div className="box-text center">
                            Open your free digital account and access seamless banking services anywhere in the world.
                        </div>
                    </div>

                    <div
                        ref={box2Ref}
                        className={`box box-cover animate__animated ${box2InView ? "animate__zoomIn" : ""}`}
                    >
                        <FontAwesomeIcon icon={faCommentsDollar} className="box-icon" />
                        <h3 className="box-title center">
                            Fast Money Transfers
                        </h3>
                        <div className="box-text center">
                            Send funds to friends and family across borders instantly, securely, and at the best rates.
                        </div>
                    </div>

                    <div
                        ref={box3Ref}
                        className={`box box-cover animate__animated ${box3InView ? "animate__zoomIn" : ""}`}
                    >
                        <FontAwesomeIcon icon={faChartPie} className="box-icon" />
                        <h3 className="box-title center">
                            Live Market Insights
                        </h3>
                        <div className="box-text center">
                            Track real-time currency trends and make smarter trading and investment decisions.
                        </div>
                    </div>
                </div>


            </div>

            {/* About Bank and Video */}
            <div className="video-section">
                <div className="hero-text-container">
                    <h2 className="box-title"> Care, Clarity, and Confidence</h2>
                    <div className="box-text">
                        Whether it’s a big decision or a small one, we all can use some honest guidance at the right time to make sure we’re getting it right. That’s why we developed our exclusive LifeDesign banking approach.
                    </div>
                    <div className="box-text">
                        Life is full of complexity. We believe your bank should help, not add to it. Work with a bank that actually cares. Get the clarity and confidence you need to make great financial decisions. This is LifeDesign banking.
                    </div>
                    <h2 className="hero-title">
                        We want to show you what it’s like to be with a bank that cares.
                    </h2>
                    <button
                        onClick={() => navigate("/login")}
                        className="delete-button">
                        Get Started
                    </button>
                </div>
                <div
                    ref={boxVidRef}
                    className={`hero-image-container animate__animated ${boxVidInView ? "animate__zoomIn" : ""}`}
                >
                    <ReactPlayer
                        url="https://youtu.be/28HpCMWfc7k"
                        playing={true}
                        muted={true}
                        loop={true}
                        width={width}
                        height={height}
                    />
                </div>
            </div>


            {/* next content here */}
            <div className="main-box-cover">
                <h2 className="text-heading center">
                    More needed - <span> More todo.</span>
                </h2>
                <div className="box-text center">
                    We offer our clients comprehensive investment solutions that are tailored to each particular client’s needs at a specific period of time.
                    For 27 years, we have been providing secure and easy U.S. banking to over 400,000 who live, travel, shop and work in the U.S. We make cross-border banking easy and secure.
                </div>
            </div>

            <div className="last-section">
                <div className="box">
                    <img
                        ref={boxImgRef}
                        src={loginIMG}
                        alt="National Trust Bank"
                        className={`box-image animate__animated ${boxImgInView ? "animate__pulse" : ""}`}
                    />
                </div>
                <div className="box">
                    <div
                        ref={box7Ref}
                        className={`icon-title-text-container animate__animated ${box7InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img src={mamitoIMG}
                            className="boxed-icon"
                            alt="WORKING AND INVESTING IN THE U.S."
                        />
                        <div className="title-text">
                            <h3 className="box-title">
                                WORKING AND INVESTING IN THE U.S.
                            </h3>
                            <div className="box-text">
                                Explore endless career and investment opportunities in the U.S. – from building a thriving career to making smart financial moves in one of the world's strongest economies.                            </div>
                        </div>
                    </div>

                    <div
                        ref={box8Ref}
                        className={`icon-title-text-container animate__animated ${box8InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img src={broIMG}
                            className="boxed-icon"
                            alt="RELOCATING AND SCHOOLING IN THE U.S."
                        />
                        <div className="title-text">
                            <h3 className="box-title">
                                RELOCATING AND SCHOOLING IN THE U.S.
                            </h3>
                            <div className="box-text">
                                Make your move to the U.S. seamless—discover the best schools, opportunities, and everything you need for a successful transition.
                            </div>
                        </div>
                    </div>

                    <div
                        ref={box9Ref}
                        className={`icon-title-text-container animate__animated ${box9InView ? "animate__zoomInRight" : ""}`}
                    >
                        <img src={girlieIMG}
                            className="boxed-icon"
                            alt="INTERNATIONAL BUSINESS WITH FOREIGNERS"
                        />
                        <div className="title-text">
                            <h3 className="box-title">
                                INTERNATIONAL BUSINESS WITH FOREIGNERS
                            </h3>
                            <div className="box-text">
                                Seamlessly conduct international transactions, manage foreign investments, and build strong financial partnerships with global banking solutions.                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default HomePage;
